import type { Theme, TypeOptions } from 'react-toastify';
import IconMdi from '@components/IconMdi';

import { typeMappingIcon, typeMappingIconColor } from './settings';

interface IconReplacementProps {
  theme: Theme;
  type?: TypeOptions;
}

export const IconReplacement = ({ type }: IconReplacementProps) => {
  const icon = typeMappingIcon[type ?? 'default'];
  const color = typeMappingIconColor[type ?? 'default'];

  return icon ? <IconMdi path={icon} size={1} className={color} /> : null;
};
